export const RECEIVE_CONSTANTS = 'RECEIVE_CONSTANTS'
export const GLOBALS_SET_LOCKED = 'GLOBALS_SET_LOCKED'

// User
export const RECEIVE_USERS = 'RECEIVE_USERS'
export const RECEIVE_USER = 'RECEIVE_USER'
export const UPDATE_USER_VALUE = 'UPDATE_USER_VALUE'

// Story
export const RECEIVE_STORY_LIST = 'RECEIVE_STORY_LIST'
export const RECEIVE_STORY_TAGS_LIST = 'RECEIVE_STORY_TAGS_LIST'
export const RECEIVE_STORY_CLASSES_LIST = 'RECEIVE_STORY_CLASSES_LIST'
export const RECEIVE_STORY = 'RECEIVE_STORY'
export const UPDATE_STORY_VALUE = 'UPDATE_STORY_VALUE'

// Story publication rule
export const RECEIVE_STORY_PUBLICATION_RULE = 'RECEIVE_STORY_PUBLICATION_RULE'

// Topic
export const RECEIVE_TOPIC_LIST = 'RECEIVE_TOPIC_LIST'
export const RECEIVE_TOPIC = 'RECEIVE_TOPIC'
export const UPDATE_TOPIC_VALUE = 'UPDATE_TOPIC_VALUE'

// author
export const RECEIVE_AUTHOR_LIST = 'RECEIVE_AUTHOR_LIST'
export const RECEIVE_AUTHOR_TAGS_LIST = 'RECEIVE_AUTHOR_TAGS_LIST'
export const RECEIVE_AUTHOR_CLASSES_LIST = 'RECEIVE_AUTHOR_CLASSES_LIST'
export const RECEIVE_AUTHOR = 'RECEIVE_AUTHOR'
export const UPDATE_AUTHOR_VALUE = 'UPDATE_AUTHOR_VALUE'

// contents
export const RECEIVE_CONTENTS_HOME = 'RECEIVE_CONTENTS_HOME'
export const RECEIVE_CONTENTS_ANALYTICS = 'RECEIVE_CONTENTS_ANALYTICS'

// tag
export const RECEIVE_TAG = 'RECEIVE_TAG'
export const RECEIVE_TAG_LIST = 'RECEIVE_TAG_LIST'
export const UPDATE_TAG_VALUE = 'UPDATE_TAG_VALUE'
